
import 'chart.js/auto';
import { Bar } from 'react-chartjs-2';
import { GetBarChartOptions, ChartPluginLegendMargin } from './_ChartUtils';
import type { ReactElement } from 'react';
import type { BarChartProps } from './_chart';

const VerticalBarChart = (props: BarChartProps): ReactElement | null => {
    const { chartData, expectedHeight, maxValue, chartDataType, xAxisLabel, yAxisLabel, decimalPlace } = props;

    if (chartData) {
        const optionToUse = GetBarChartOptions({ useHorizontalOptions: false, maxValue, chartDataType, xAxisLabel, yAxisLabel, decimalPlace });

        const barMaxHeight = expectedHeight || 600;

        return (
            <Bar
                height={expectedHeight}
                options={optionToUse}
                data={chartData.data ? chartData.data : { datasets: [] }}
                plugins={[ChartPluginLegendMargin(24)]}
                style={{ height: `${barMaxHeight}px`, maxHeight: `${barMaxHeight}px` }}
            />
        );
    }

    return null;
};

export default VerticalBarChart;
